<template>
  <div>
  <v-dialog v-model="intDialogVisible" max-width="80%" class="addValueModal addComment">

    <v-card>
      <div class="close" @click="close">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.85219 2.15L7.80219 7.1L12.7522 2.15C12.9522 1.95 13.2622 1.95 13.4622 2.15C13.6622 2.35 13.6622 2.66 13.4622 2.86L8.51219 7.8L13.4622 12.75C13.6622 12.95 13.6622 13.26 13.4622 13.46C13.2622 13.66 12.9522 13.66 12.7522 13.46L7.80219 8.51L2.85219 13.46C2.65219 13.66 2.34219 13.66 2.14219 13.46C1.94219 13.26 1.94219 12.95 2.14219 12.75L7.10219 7.8L2.15219 2.85C1.95219 2.66 1.95219 2.34 2.15219 2.15C2.34219 1.95 2.66219 1.95 2.85219 2.15Z" fill="#0A2071"/>
        </svg>

      </div>
      <!-- <v-card-title>
        <span @click="close" class="close">X</span>
      </v-card-title> -->
      <v-card-text>
        <div class="row text-center">
          <h3 class="primary--text formName">{{$t("assessments and next steps")}}</h3>

        </div>
        <div class="row mt20">

          <div class="" v-if="details">
      <div class="table-header" >
          <div class="table-cell header-cell withsort" @click="sortBy('name')">
            {{ $t("ASSESSMENT NAME") }}
            <img :src="require('@/assets/orderby.svg')" class=""  alt="">
          </div>
          <div class="table-cell header-cell withsort"  @click="sortBy('collab_interest_level')">
            {{ $t("INTEREST") }}
            <img :src="require('@/assets/orderby.svg')" >
          </div>
          <div class="table-cell header-cell withsort" @click="sortBy('nextstep')">
            {{ $t("NEXT STEP") }}
          <img :src="require('@/assets/orderby.svg')">
        </div>
          <div class="table-cell header-cell">{{ $t("KEY ACTION") }}</div>
          <div class="table-cell header-cell">{{ $t("DEADLINE") }}</div>
          <div class="table-cell header-cell">{{$t('OWNER')}}</div>
      </div>

      <div class="table-row" v-for="(det,d) in sortedItems" :key="d">
          <div class="table-cell assessmentname">
            <a :href="'/assessment_results/'+det.assessment._id.$oid" target="_blank" class="assessmentname">{{det.assessment.name}}</a>
          </div>
          <div class="table-cell">{{ $t(det.collab_interest_level)}}</div>
          <div class="table-cell">
            <div  class="innopearl_input_m select" >
              <select  v-model="det.nextstep" placeholder="" @change="onChangeNextStep($event,det)">
                <option v-for="(step, n ) in available_next_steps " :key="n" :value="step">{{step.name}}</option>
              </select>
            </div>
          </div>
          <div class="table-cell">
            <InlineEditor v-model="det.keyaction_text" type="textarea" :rows="4" @save="handleSave($event, det, 'keyaction_text')"/>
          </div>
          <div class="table-cell">
            <InlineEditor v-if="det.keyaction_deadline" v-model="det.keyaction_deadline.date" type="date"  @save="handleSave($event, det, 'keyaction_deadline')"/>
            <InlineEditor v-else v-model="extra" type="date"  @save="handleSave($event, det, 'keyaction_deadline')"/>

          </div>
          <div class="table-cell">
            <InlineEditor v-model="det.keyaction_owner" type="text" @save="handleSave($event, det, 'keyaction_owner')"/>
          </div>
      </div>


  </div>

        </div>

      </v-card-text>
    </v-card>
  </v-dialog>
  <ToastContainer />
</div>
</template>

<script>
import api from '@/tools/api';
import { toast } from 'vue-sonner'
import InlineEditor from '@/components/InlineEditor.vue'

export default {
  props: {
    dialogVisible: Boolean,
    startup:Object,
  },
  components:{
    InlineEditor
  },
  data () {
    return{
      extra:null,
      details :null,
      available_next_steps : [],
      sortKey: '',
      sortDirection: 'asc', // 'asc' or 'desc'
    }
  },
  methods:{
    close(){
        this.$emit('close',false)
    },
    handleSave(newValue, det, field) {
      var update = true;
      switch (field) {
        case 'keyaction_owner':
            det.keyaction_owner = newValue;
          break;
        case 'keyaction_deadline':
          if(  det.keyaction_deadline)det.keyaction_deadline.date = newValue;
          else det.keyaction_deadline = {date : newValue};
        break;
        case 'keyaction_text':
            det.keyaction_text = newValue;
        break;
        default:
          update = false;
      }
      this.extra = null;
          if(update){
            var v = {
              _id : det._id.$oid,
              det : det,
            };
            api.post(process.env.VUE_APP_API_URL+"/restrict/update_key_actions",
                v,
                {
                  headers: {
                      'Content-Type': 'application/json',
                }
              }).then( (r) => {
                console.log(r.data);
                toast.success(this.$t("YOUR DATA IS SAVED"));
                api.get(process.env.VUE_APP_API_URL+"/restrict/get_all_startup_next_step/"+this.startup._id.$oid).then( (r) => {
                  console.log("IS ASSESS");
                  console.log("details",r.data);
                  this.details = r.data;


                });
              }).catch( (e) => {
                toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")

                console.log(e);toast.error()
              });
          }




     console.log(`Saving ${field}: ${newValue} for item ${det}`)
   },
    sortBy(key) {
     // Toggle sorting direction
     if (this.sortKey === key) {
       this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
     } else {
       this.sortKey = key;
       this.sortDirection = 'asc';
     }
   },
    onChangeNextStep(event,det) {
      console.log("onChangeNextStep",det);
      this.sortKey = '';
      var v = {
        _id : det._id.$oid,
        nextstep : det.nextstep._id.$oid
      };
      api.post(process.env.VUE_APP_API_URL+"/restrict/update_next_step",
          v,
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r.data);
          toast.success(this.$t("YOUR DATA IS SAVED"));
          api.get(process.env.VUE_APP_API_URL+"/restrict/get_all_startup_next_step/"+this.startup._id.$oid).then( (r) => {
            console.log("IS ASSESS");
            console.log("details",r.data);
            this.details = r.data;


          });
        }).catch( (e) => {
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")

          console.log(e);toast.error()
        });
    }
  },
  computed: {
    intDialogVisible: {
      get: function () {
        if (this.dialogVisible) {
          // Some dialog initialization code could be placed here
          // because it is called only when this.dialogVisible changes
        }

        return this.dialogVisible
      },
      set: function (value) {
             if (!value) {
                this.$emit('close', value);
             }
      }
    },
    sortedItems() {
      const collabInterestOrder = {
        low: 1,
        medium: 2,
        high: 3
      };
      // Copy the array before sorting to avoid mutating original data
      return [...this.details].sort((a, b) => {
        if (this.sortKey) {
          if(this.sortKey == "name"){
            let modifier = this.sortDirection === 'asc' ? 1 : -1;
            if (a.assessment.name < b.assessment.name) return -1 * modifier;
            if (a.assessment.name > b.assessment.name) return 1 * modifier;
          }
          if(this.sortKey == "collab_interest_level"){
            let modifier = this.sortDirection === 'asc' ? 1 : -1;

            const valueA = collabInterestOrder[a.collab_interest_level];
            const valueB = collabInterestOrder[b.collab_interest_level];
            return (valueA - valueB) * modifier;


          }
          if(this.sortKey == "nextstep"){
            let modifier = this.sortDirection === 'asc' ? 1 : -1;
            const valueA = this.available_next_steps.findIndex(item => item._id.$oid == a.nextstep._id.$oid);
            console.log(this.available_next_steps);
            console.log(a.nextstep);
            console.log(valueA);
            const valueB = this.available_next_steps.findIndex(item => item._id.$oid == b.nextstep._id.$oid);
            return (valueA - valueB) * modifier;

          }
        }


        return 0;
      });
    },
  },
  watch: {
    dialogVisible: function(){

      if(this.dialogVisible == true){
        api.get(process.env.VUE_APP_API_URL+"/restrict/available_next_steps").then( (r) => {
          this.available_next_steps = r.data;
        });
        api.get(process.env.VUE_APP_API_URL+"/restrict/get_all_startup_next_step/"+this.startup._id.$oid).then( (r) => {
          console.log("IS ASSESS");
          console.log("details",r.data);
          this.details = r.data;


        });


      }
    },

  }

}
</script>

<style media="screen" scoped>
  .addValueModal .v-card{
    padding:20px;
    padding-top:20px;
    padding-bottom: 50px;
    border-radius: 8px;
  }
  .addValueModal .v-field__outline{
    display:none;
  }
  .mt20{
    margin-top:20px;
  }
  .formName{
    text-align: center;
    font-size: 21px;
    line-height: 25px;
    color: #3783C5;
    font-weight: 600;
    text-transform: uppercase;
  }


.close{
  position: absolute;
    right: 20px;
    top: 20px;
    color: #FFF;
    cursor: pointer;
    font-size: 14px;
    line-height: 25px;
}
.formName{
  padding-right:30px;
}
.flexIt{
  display:flex;
  width:100%;
  flex-wrap: wrap;
  gap: 20px;
  margin-top:10px;
  align-content: center;
  align-items: center;
  align-self: center;
}

.assessTypeChoice{
  background:#F0F5FA;
  border-radius:25px;
  border:2px solid #F0F5FA;
  padding:25px;
  text-align:center;
  width:100%;
  display:flex;
  flex-direction: column;
  gap:20px;
  height: 100%;
}

.assessTypeChoice.selected{
  border-color:#3783C5;
}

.assessTypeChoice input{
  display:none;
}

.imageInternal{
  transform: translateY(25px);
    width: 200px;
    margin: auto;
}
.imageInno{
  width:130px;
  margin:auto;
}

.actionButn{
  display:flex;gap:20px;flex-direction: row;justify-content: center;
}

.smallModalBtn{
  background: #4C81C0;
  border:1px solid #4C81C0;
  color: #fff !important;
  font-size:15px !important;
  padding: 7px 30px !important;
  border-radius: 200px;
}

.smallModalBtnInverted{
  background: #FFF;
    border:1px solid #4C81C0;
  color: #4C81C0 !important;
  font-size:15px !important;
  padding: 7px 30px !important;
  border-radius: 200px;
}

.smallModalBtn:disabled{
opacity:0.2;
}


  .assessment-type {
      display: flex;
      align-items: center;
      margin-bottom:30px;
  }

  .radio-label {
      display: flex;
      align-items: center;
      margin-right: 20px; /* Spacing between options */
      cursor: pointer; /* Change cursor to pointer for better UX */
  }

  input[type="radio"] {
      display: none; /* Hide the default radio button */
  }

  .custom-radio {
      width: 25px; /* Circle diameter */
      height: 25px; /* Circle diameter */
      border: 2px solid #5081C1; /* Light gray border for unselected state */
      border-radius: 50%; /* Make it a circle */
      margin-right: 8px; /* Space between the circle and the text */
      transition: border-color 0.3s, background-color 0.3s; /* Smooth transition for color changes */
  }

  .radio-text {
      font-weight: 600;
      color: #04246A; /* Dark color for the text */
  }

  input[type="radio"]:checked + .custom-radio {
      border-color: #5081C1; /* Change border color when selected */
      background-color: #5081C1; /* Blue background when selected */
  }

  .zone_input_name{
    text-align: left;
    font-size: 18px;
    line-height: 21px;
    color: rgba(4, 36, 106, 1);
    font-weight: 600;
    margin-bottom:10px;
  }
  .zone_input_header{
    display:flex;
    gap: 10px;
    position:relative;
  }


  .innopearl_input_m.select select{
  width:100%;
  -webkit-appearance: none;
 -moz-appearance: none;
 background: transparent;
 background-image: url('@/assets/smallTriangle.svg');
 background-repeat: no-repeat;
 background-position-x: calc(100% - 10px);
 background-position-y: 50%;
  }
  /* .innopearl_input.select select::after{
      position:absolute;
    top: calc(50% - 11px);
      right:30px;
      content:  url('@/assets/triangle.svg');
  } */

  .table-container {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.table-header {
    display: flex;
    background-color: #3783C5; /* Header background color */
    color: white;
    font-weight: bold;
    border-radius: 200px;
  padding: 10px;
  font-size:12px;
}

.table-row {
    display: flex;
    background-color: rgba(55,131,107,.07); /* Light background for rows */
    border-radius: 200px;
  padding: 10px;
  margin-top:10px;
  margin-bottom:10px;
}



.table-cell {
    flex: 1; /* Equal distribution of cell widths */
    padding: 12px; /* Padding inside cells */
    text-align: left; /* Align text to the left */
    position:relative;
    padding-left: 20px;
    padding-right:20px;
    align-content: center;
}

.table-cell:not(:last-child):after {
position: absolute;
top:5px;
bottom:5px;
width:1px;
right:0;
background:#FFF;
content:'';
}

.header-cell {
    text-transform: uppercase; /* Uppercase header text */
    padding: 16px; /* More padding for headers */
}

.assessmentname{
  color:#B38D2F;
  font-weight: 600;
}

.withsort{
  cursor:pointer;
}


</style>
